import { useState, useEffect } from 'react'

const KEY = 'adops_density'

export function useDensity() {
  const [compact, setCompact] = useState(() => {
    try { return localStorage.getItem(KEY) === 'compact' } catch { return false }
  })
  useEffect(() => {
    document.body.classList.toggle('density-compact', compact)
    try { localStorage.setItem(KEY, compact ? 'compact' : 'comfortable') } catch {}
  }, [compact])
  return [compact, setCompact]
}

export function DensityToggle() {
  const [compact, setCompact] = useDensity()
  return (
    <button className="btn btn-secondary" onClick={() => setCompact(c => !c)}
      title={compact ? 'Switch to comfortable spacing' : 'Switch to compact spacing (fit more on screen)'}>
      {compact ? '⊟ Compact' : '⊞ Comfortable'}
    </button>
  )
}
